import { ReactNode } from "react";

interface EmptyTextProps {
  className?: string;
  children?: ReactNode;
}

/**
 * `div` with the height of the inherited or specified font size
 *
 * Children will take up space, but will not be visible and will be hidden to screen readers.
 */
export const EmptyText = ({
  className,
  children,
}: EmptyTextProps): JSX.Element => (
  <div className={`empty-text invisible ${className}`} aria-hidden>
    {children}
  </div>
);
